module.exports = __webpack_public_path__ + "img/img-box-services-design-left.f2347b95.png";